<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          Product Coupons Details
        </li>
      </ol>

      <div class="row">
        <div class="col-md-12">
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
        </div>

        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input type="text" class="search-query form-control" placeholder="Search" v-model="searchText"/>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button type="button" v-on:click="getAllCoupons(1)" class="btn btn-raised btn-primary submitbtn">
              Search
            </button>
          </div>
        </div>

        <div class="col-md-3" v-if="$can('Create','Loyalty::Coupons')">
          <div class="user-buttonall">
            <ul>
              <li>
                <div class="form-group">
                  <router-link to="/generateCoupons">Generate Coupons</router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button type="button" @click="filterTotalCoupon" class="btn btn-default" :class="{'active': FilterSetOnClick==''}">
            Total Coupons <span class="badge">{{ TotalCoupon }}</span>
          </button>
          <button type="button" @click="filterAvaialable" class="btn btn-default" :class="{'active': FilterSetOnClick=='Available'}">
            Marry Coupons <span class="badge">{{ AvailableCoupon }}</span>
          </button>
          <button type="button" @click="filterNewGenerated" class="btn btn-default" :class="{'active': FilterSetOnClick=='NewGenerate'}">
            New Generated Coupons <span class="badge">{{ GeneratedCoupon }}</span>
          </button>
        </div>

        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading"><div class="panel-ctrls"></div></div>

            <div class="panel-body no-padding visibility">
              <table class="table table-striped table-bordered" cellspacing="0" width="100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <td>Serial Number</td>
                    <td>Product Name</td>
                    <th>Points</th>
                    <th>Reborer Status</th>
                    <th>Mechanic Status</th>
                    <th>Grinder Status</th>
                    <th>Grinder Reborer Status</th>
                    <th>Retailer Status</th>
                    <th>Updation Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in coupon_data" :key="item.id" class="gradeC">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td class="left-align">{{ item.coupon }}</td>
                    <td>{{ item.serial_number }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.ReborerStatus }}</td>
                    <td>{{ item.MechanicStatus }}</td>
                    <td>{{ item.GrinderStatus }}</td>
                    <td>{{ item.GrinderReborerStatus }}</td>
                    <td>{{ item.RetailerStatus }}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                    <td>
                      <a href="#" @click="DeactivateCoupon(item.id, item.Active)">
                        {{ item.Active == "1" ? "Active" : "InActive" }}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="handlePaginationClick"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'">
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment';

export default {
  name: 'ProductCouponDetails',
  components: { Paginate },
  data() {
    return {
      coupon_data: [],
      searchText: '',
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message: '',
      AvailableCoupon: 0,
      GeneratedCoupon: 0,
      TotalCoupon: 0,
      FilterSetOnClick: '',
      SuccessMessage: '',
      ErrorMessage: ''
    };
  },
  methods: {
    DeactivateCoupon(id, TypeStatus) {
      const params = "id=" + id + "&Type=" + (TypeStatus == "1" ? "Deactivate" : "Active");
      let _this = this;
      commonServices.put('kspgAPI/Coupon/deactivateActivate', params)
        .then(function (response) {
          if (response.data.status) {
            _this.getAllCoupons(_this.currentPage);
            _this.SuccessMessage = response.data.message;
          }
        })
        .catch(function (e) {
          if (e.response && e.response.data && e.response.data.message) {
            _this.ErrorMessage = e.response.data.message;
          } else if (e.message) {
            _this.ErrorMessage = e.message;
          } else {
            _this.ErrorMessage = e.toString();
          }
          if (e.response && e.response.data && e.response.data.error === "Invalid API key ") {
            _this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
    },

    filterTotalCoupon() { this.FilterSetOnClick = ''; this.getAllCoupons(1); },
    filterNewGenerated() { this.FilterSetOnClick = 'NewGenerate'; this.getAllCoupons(1); },
    filterAvaialable() { this.FilterSetOnClick = 'Available'; this.getAllCoupons(1); },

    getRequestParams(searchText, page, pageSize) {
      const params = {};
      if (this.FilterSetOnClick) params['FilterSetOnClick'] = this.FilterSetOnClick;
      if (searchText) params['searchText'] = searchText;
      if (page) params['page'] = page - 1; // API is 0-indexed
      if (pageSize) params['size'] = pageSize;
      return params;
    },

    getAllCoupons(pageNum) {
      this.currentPage = pageNum;
      const params = this.getRequestParams(this.searchText, pageNum, this.pageSize);
      let _this = this;
      let loader = this.$loading.show();

      commonServices.get('kspgAPI/Coupon/productList', params)
        .then(function (response) {
          const { coupon_data } = response.data;
          _this.coupon_data = coupon_data || [];
          loader.hide();
        })
        .catch(function (e) {
          loader.hide();
          if (e.response && e.response.data && e.response.data.message) {
            _this.ErrorMessage = e.response.data.message;
          } else if (e.message) {
            _this.ErrorMessage = e.message;
          } else {
            _this.ErrorMessage = e.toString();
          }
          if (e.response && e.response.data && e.response.data.error === "Invalid API key ") {
            _this.$router.push({ name: 'login' });
          }
        });

      commonServices.get('kspgAPI/Coupon/productListCounts', params)
        .then(function (response) {
          const { TotalPage, AvailableCoupon, GeneratedCoupon, TotalCoupon } = response.data;
          _this.TotalPage = TotalPage || 1;
          _this.AvailableCoupon = AvailableCoupon || 0;
          _this.GeneratedCoupon = GeneratedCoupon || 0;
          _this.TotalCoupon = TotalCoupon || 0;
        })
        .catch(function (e) {
          // eslint-disable-next-line no-console
          console.error("Error loading coupon counts:", e);
        });
    },

    handlePaginationClick(pageNum) {
      this.getAllCoupons(pageNum);
    },

    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },

    submitFile() {
      let formData = new FormData();
      formData.append('ProductSerails', this.uploadFile);
      let _this = this;
      let loader = this.$loading.show();

      commonServices.post_upload_file('kspgAPI/Coupon/upload', formData)
        .then(function (response) {
          _this.message = response.data.message;
          loader.hide();
        })
        .catch(function (e) {
          loader.hide();
          if (e.response && e.response.data && e.response.data.message) {
            _this.ErrorMessage = e.response.data.message;
          } else if (e.message) {
            _this.ErrorMessage = e.message;
          } else {
            _this.ErrorMessage = e.toString();
          }
        });
    }
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) return input_date;
      return moment(String(input_date)).format('DD-MM-YYYY');
    }
  }
};
</script>

<style scoped>
.visibility { visibility: visible !important; }
.search-button { background-color: #555555; color: #ffffff; }
.left-align { text-align: left !important; }
</style>
